module.exports = __webpack_public_path__ + "static/media/2-item-b.347d8005.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/2-item-b.jpg
// module id = 1158
// module chunks = 33